import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "@environments/environment";
import { Messages } from '@app/constants/constant';
import { map } from "rxjs/internal/operators/map";

@Injectable()
export class SourceAddEditService {
  
  constructor(private _httpClient: HttpClient
    ) {
  }

  editSource(source : any)
  {
    let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    let body = {
        sourceName : source.name,
        sourceId : source.id,
        sourceTypeId : source.selectedSourceType.id,
        deleted : !source.isActive, 
        loggedInUser : JSON.parse(localStorage.getItem("currentUser")).user.id
    };
      return this._httpClient
        .post(`${environment.apiUrl}/${Messages.endpoint.editSource}`, body, { headers : headers }).pipe(map(res => {
          return res;
          }));
  }

  addSource(source : any)
  {
    let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    let body = {
        sourceName : source.name,
        sourceTypeId :source.selectedSourceType.id,
        loggedInUser : JSON.parse(localStorage.getItem("currentUser")).user.id
    };
      return this._httpClient
        .post(`${environment.apiUrl}/${Messages.endpoint.addSource}`, body, { headers : headers }).pipe(map(res => {
          return res;
          }));
  }

getAllAgencies(params : any, sourceType : any)
{
  let queryString = "";
  if (params)
  {
     queryString =  "?" + params.toQueryString();
  }
  var endpointSource="source/sourceType-superadmin/"+ sourceType.id;
   return this._httpClient
     .get(`${environment.apiUrl}/${endpointSource}${queryString}${Messages.endpoint.sourceNameParams}`).pipe(map((res : any) => {
        return res.content;
       }));
}

getAllSourceTypes(params : any)
{
  let queryString = "";
  if (params)
  {
     queryString =  "?" + params.toQueryString();
  }
  var endpointSource= "source-type/source";
   return this._httpClient
     .get(`${environment.apiUrl}/${endpointSource}/${queryString}`).pipe(map((res : any) => {
        return res.content;
       }));
}
  
}
